import { createFileRoute, redirect } from '@tanstack/react-router';

import { DEFAULT_REDIRECT_URL } from '@/constants';
import { Upgrade } from '@/features/organizations';
import { checkOrganizationTrialStatus } from '@/hooks';
import { createClientFromAuth } from '@/utils';

export const Route = createFileRoute('/_auth/upgrade')({
  component: Upgrade,

  beforeLoad: async ({ context }) => {
    const { auth } = context;
    const client = await createClientFromAuth(auth);
    const organization = await client.getOrganization('me');
    const { hasUpgraded } = checkOrganizationTrialStatus(organization);

    if (hasUpgraded) {
      throw redirect({ to: DEFAULT_REDIRECT_URL });
    }
  },
});
